import { Link } from "react-router-dom";
import "./Logo.css";

const Logo = (props) => {
  return (
  
      <div className="logo-box">
        <Link to="/">
         <svg
          version="1.0"
          xmlns="http://www.w3.org/2000/svg"
          width={props.width}
          height={props.height}
          viewBox="0 0 889.000000 226.000000"
          preserveAspectRatio="xMidYMid meet"
        >
          <g
            transform="translate(0.000000,226.000000) scale(0.100000,-0.100000)"
            fill={props.logoColor}
            stroke="none"
          >
            <path
              d="M1085 2076 c-315 -61 -570 -260 -707 -552 -67 -145 -82 -215 -82
            -404 0 -138 4 -178 22 -243 46 -166 137 -324 256 -443 119 -119 277 -210 443
            -256 113 -31 373 -31 486 0 286 79 513 271 639 538 58 124 79 218 85 369 4
            105 1 148 -15 227 -47 224 -180 439 -357 575 -87 67 -245 145 -350 173 -103
            28 -318 36 -420 16z m700 -502 c108 -131 120 -149 119 -183 -1 -46 -33 -94
            -74 -113 l-30 -13 -2 -270 -3 -270 -490 0 -490 0 -5 267 -5 267 -35 23 c-42
            29 -80 83 -80 114 0 16 44 76 126 174 l126 150 362 0 361 0 120 -146z"
            />
            <path
              d="M1027 1545 c-37 -74 -67 -145 -67 -156 0 -12 15 -36 34 -55 28 -28
            41 -34 78 -34 46 0 81 18 98 51 8 14 60 296 60 324 0 3 -30 5 -68 5 l-67 0
            -68 -135z"
            />
            <path
              d="M1400 1518 c26 -154 29 -163 59 -190 24 -21 41 -28 74 -28 51 0 84
            21 103 66 14 33 13 37 -56 174 l-70 140 -68 0 -69 0 27 -162z"
            />
            <path
              d="M918 1282 l-38 -25 0 -119 0 -118 425 0 425 0 0 118 0 118 -41 27
            -41 27 -30 -22 c-17 -11 -51 -23 -77 -26 -38 -3 -53 1 -84 22 l-38 26 -31 -21
            c-17 -12 -51 -24 -77 -27 -37 -3 -53 1 -84 22 l-38 26 -30 -23 c-43 -31 -125
            -31 -168 1 -16 12 -31 22 -33 21 -2 -1 -20 -13 -40 -27z"
            />
            <path
              d="M4152 1668 c19 -24 68 -85 108 -135 l74 -93 88 0 c48 0 88 3 88 7 0
            4 -33 64 -72 135 l-73 128 -124 0 -123 0 34 -42z"
            />
            <path
              d="M7030 1235 l0 -415 90 0 90 0 0 88 c0 75 3 91 23 115 l22 28 69 -116
            68 -115 109 0 c60 0 109 2 109 5 0 4 -81 121 -186 272 l-44 61 94 105 c52 58
            97 110 101 116 4 8 -27 11 -102 11 l-108 0 -77 -118 -78 -117 0 248 0 247 -90
            0 -90 0 0 -415z"
            />
            <path
              d="M2300 1215 l0 -395 250 0 250 0 0 75 0 75 -160 0 -160 0 0 90 0 90
            145 0 145 0 0 75 0 75 -145 0 -145 0 0 80 0 80 155 0 155 0 0 75 0 75 -245 0
            -245 0 0 -395z"
            />
            <path
              d="M4876 1558 c-6 -53 -46 -687 -46 -720 0 -16 11 -18 85 -18 l85 0 1
            58 c0 31 6 167 13 302 l12 245 18 -80 c19 -83 92 -358 121 -458 l17 -58 71 3
            71 3 78 250 c42 138 83 273 91 300 12 47 14 31 21 -243 4 -162 10 -300 13
            -308 4 -10 26 -14 89 -14 l84 0 0 45 c0 54 -28 572 -36 673 l-6 72 -117 0
            -117 0 -39 -117 c-21 -65 -57 -186 -80 -270 l-41 -152 -28 120 c-15 66 -47
            186 -70 267 l-43 147 -121 3 -120 3 -6 -53z"
            />
            <path
              d="M3800 1535 l-85 -20 -3 -62 -3 -63 -34 0 -35 0 0 -65 0 -65 35 0 35
            0 0 -130 c0 -71 5 -152 11 -180 12 -59 49 -107 96 -126 38 -16 140 -18 178 -4
            25 9 26 13 23 72 l-3 63 -50 5 c-68 7 -75 23 -75 178 l0 122 65 0 65 0 0 65 0
            65 -65 0 -64 0 -3 83 -3 83 -85 -21z"
            />
            <path
              d="M8480 1535 l-85 -20 -3 -62 -3 -63 -34 0 -35 0 0 -65 0 -65 35 0 35
            0 0 -130 c0 -71 5 -152 11 -180 12 -59 49 -107 96 -126 38 -16 140 -18 178 -4
            25 9 26 13 23 72 l-3 63 -50 5 c-68 7 -75 23 -75 178 l0 122 65 0 65 0 0 65 0
            65 -65 0 -64 0 -3 83 -3 83 -85 -21z"
            />
            <path
              d="M3221 1388 c-18 -6 -48 -26 -67 -43 l-33 -31 -3 35 -3 36 -77 3 -78
            3 0 -286 0 -285 90 0 90 0 0 175 c0 186 7 222 49 245 36 19 86 12 112 -16 23
            -25 24 -30 27 -215 l4 -189 89 0 90 0 -3 213 c-3 199 -4 215 -27 260 -33 68
            -85 100 -165 104 -33 1 -76 -3 -95 -9z"
            />
            <path
              d="M4295 1393 c-62 -14 -115 -36 -115 -49 0 -27 24 -104 33 -104 4 0 17
            5 28 11 66 35 198 28 219 -11 18 -34 12 -40 -44 -40 -83 0 -180 -34 -225 -79
            -92 -92 -70 -241 43 -292 75 -34 193 -16 236 36 14 17 15 16 20 -11 5 -29 5
            -29 85 -32 l80 -3 -3 193 c-1 106 -8 213 -14 238 -16 61 -79 123 -140 138 -45
            12 -162 14 -203 5z m182 -355 c-5 -40 -13 -59 -32 -75 -36 -31 -98 -31 -119
            -1 -43 61 19 123 128 127 l29 1 -6 -52z"
            />
            <path
              d="M6005 1393 c-62 -14 -115 -36 -115 -49 0 -27 24 -104 33 -104 4 0 17
            5 28 11 66 35 198 28 219 -11 18 -34 12 -40 -44 -40 -83 0 -180 -34 -225 -79
            -92 -92 -70 -241 43 -292 75 -34 193 -16 236 36 14 17 15 16 20 -11 5 -29 5
            -29 85 -32 l80 -3 -3 193 c-1 106 -8 213 -14 238 -16 61 -79 123 -140 138 -45
            12 -162 14 -203 5z m182 -355 c-5 -40 -13 -59 -32 -75 -36 -31 -98 -31 -119
            -1 -43 61 19 123 128 127 l29 1 -6 -52z"
            />
            <path
              d="M6795 1382 c-17 -11 -43 -33 -57 -50 l-26 -31 -7 44 -6 45 -75 0 -74
            0 0 -285 0 -285 90 0 90 0 0 158 c0 214 20 252 133 252 l48 0 -3 83 -3 82 -40
            3 c-26 1 -51 -4 -70 -16z"
            />
            <path
              d="M7854 1384 c-103 -38 -174 -139 -182 -260 -9 -136 39 -229 146 -281
            52 -26 66 -28 172 -28 72 0 130 5 154 14 l38 13 -6 49 c-10 77 -12 79 -54 67
            -62 -18 -172 -14 -215 6 -31 16 -67 58 -67 81 0 3 83 5 185 5 l184 0 7 35 c9
            52 -14 158 -46 209 -43 67 -104 99 -199 103 -50 2 -90 -3 -117 -13z m141 -114
            c23 -9 55 -60 55 -90 0 -6 -40 -10 -106 -10 -105 0 -105 0 -99 23 22 73 80
            103 150 77z"
            />
            <path
              d="M6080 460 c0 -143 1 -150 20 -150 19 0 20 7 20 150 0 143 -1 150 -20
            150 -19 0 -20 -7 -20 -150z"
            />
            <path
              d="M7790 460 c0 -143 1 -150 20 -150 17 0 20 7 20 44 0 25 4 47 8 50 4
            2 23 -18 41 -45 25 -35 41 -49 58 -49 12 0 23 1 23 3 0 2 -18 28 -40 57 -22
            29 -40 58 -40 64 0 6 17 27 37 48 36 37 36 38 13 38 -17 0 -37 -14 -62 -42
            l-37 -43 -1 88 c0 80 -2 87 -20 87 -19 0 -20 -7 -20 -150z"
            />
            <path
              d="M2335 518 c39 -73 45 -91 45 -145 0 -56 2 -63 20 -63 18 0 20 7 20
            60 0 54 5 70 45 139 25 43 45 81 45 84 0 4 -9 7 -20 7 -14 0 -29 -18 -54 -67
            l-34 -68 -33 68 c-26 53 -38 67 -56 67 -21 0 -20 -4 22 -82z"
            />
            <path
              d="M4000 598 c0 -3 20 -67 44 -144 39 -124 46 -139 67 -142 22 -2 27 7
            72 136 26 76 47 141 47 145 0 4 -9 7 -19 7 -16 0 -27 -21 -59 -120 l-39 -119
            -34 117 c-30 100 -38 117 -57 120 -12 2 -22 2 -22 0z"
            />
            <path d="M4414 589 c-10 -17 23 -46 37 -32 7 7 9 19 6 27 -7 18 -33 21 -43 5z" />
            <path
              d="M6606 513 c-4 -48 -9 -114 -12 -145 -5 -53 -4 -58 14 -58 17 0 20 10
            26 77 3 42 6 94 6 117 1 35 6 25 38 -74 48 -147 59 -150 101 -36 17 47 34 98
            38 113 7 25 8 23 14 -22 4 -27 8 -78 8 -112 1 -57 3 -63 22 -63 20 0 20 3 14
            123 -8 160 -10 167 -40 167 -21 0 -27 -11 -61 -114 l-38 -114 -36 112 c-33
            101 -38 111 -62 114 -25 3 -26 2 -32 -85z"
            />
            <path
              d="M5033 573 c-7 -2 -13 -16 -13 -29 0 -15 -6 -24 -15 -24 -8 0 -15 -7
            -15 -15 0 -8 7 -15 15 -15 12 0 15 -15 15 -74 0 -84 13 -106 61 -106 35 0 41
            27 7 32 -21 3 -23 9 -26 76 -3 71 -3 72 23 72 16 0 25 6 25 15 0 9 -9 15 -25
            15 -21 0 -25 5 -25 30 0 30 -4 33 -27 23z"
            />
            <path
              d="M8553 573 c-7 -2 -13 -16 -13 -29 0 -15 -6 -24 -15 -24 -8 0 -15 -7
            -15 -15 0 -8 7 -15 15 -15 12 0 15 -15 15 -74 0 -84 13 -106 61 -106 35 0 41
            27 7 32 -21 3 -23 9 -26 76 -3 71 -3 72 23 72 16 0 25 6 25 15 0 9 -9 15 -25
            15 -21 0 -25 5 -25 30 0 30 -4 33 -27 23z"
            />
            <path
              d="M2721 506 c-65 -36 -66 -151 -2 -186 49 -25 128 -2 149 45 23 51 5
            122 -37 145 -27 14 -81 12 -110 -4z m85 -24 c16 -10 34 -48 34 -70 0 -30 -38
            -72 -65 -72 -27 0 -65 42 -65 72 0 22 18 60 34 70 6 4 20 8 31 8 11 0 25 -4
            31 -8z"
            />
            <path
              d="M3080 437 c0 -70 3 -87 20 -105 24 -26 66 -29 98 -6 20 14 22 14 22
            0 0 -9 7 -16 15 -16 12 0 15 18 15 105 0 98 -1 105 -20 105 -18 0 -20 -7 -20
            -73 0 -59 -4 -77 -18 -90 -23 -21 -36 -21 -56 -1 -12 11 -16 36 -16 90 0 67
            -2 74 -20 74 -18 0 -20 -7 -20 -83z"
            />
            <path
              d="M3480 415 c0 -98 1 -105 20 -105 18 0 20 7 20 66 0 74 12 104 40 104
            13 0 20 7 20 20 0 25 -26 26 -52 3 -17 -15 -18 -15 -18 0 0 10 -7 17 -15 17
            -12 0 -15 -18 -15 -105z"
            />
            <path
              d="M4420 415 c0 -98 1 -105 20 -105 19 0 20 7 20 105 0 98 -1 105 -20
            105 -19 0 -20 -7 -20 -105z"
            />
            <path
              d="M4690 415 c0 -98 1 -105 20 -105 18 0 20 7 20 66 0 74 12 104 40 104
            13 0 20 7 20 20 0 25 -26 26 -52 3 -17 -15 -18 -15 -18 0 0 10 -7 17 -15 17
            -12 0 -15 -18 -15 -105z"
            />
            <path
              d="M5310 437 c0 -70 3 -87 20 -105 24 -26 66 -29 98 -6 20 14 22 14 22
            0 0 -9 7 -16 15 -16 12 0 15 18 15 105 0 98 -1 105 -20 105 -18 0 -20 -7 -20
            -73 0 -59 -4 -77 -18 -90 -23 -21 -36 -21 -56 -1 -12 11 -16 36 -16 90 0 67
            -2 74 -20 74 -18 0 -20 -7 -20 -83z"
            />
            <path
              d="M5723 513 c-7 -2 -13 -11 -13 -19 0 -11 9 -13 42 -8 33 6 44 4 55
            -11 20 -28 16 -35 -17 -35 -43 0 -89 -26 -96 -54 -13 -53 40 -90 98 -68 16 6
            28 6 28 1 0 -5 9 -9 21 -9 20 0 21 4 18 86 -4 76 -7 88 -28 105 -22 18 -79 24
            -108 12z m97 -122 c0 -46 -61 -66 -84 -28 -9 15 -7 21 8 33 30 21 76 19 76 -5z"
            />
            <path
              d="M7123 513 c-7 -2 -13 -11 -13 -19 0 -11 9 -13 42 -8 33 6 44 4 55
            -11 20 -28 16 -35 -17 -35 -43 0 -89 -26 -96 -54 -13 -53 40 -90 98 -68 16 6
            28 6 28 1 0 -5 9 -9 21 -9 20 0 21 4 18 86 -4 76 -7 88 -28 105 -22 18 -79 24
            -108 12z m97 -122 c0 -46 -61 -66 -84 -28 -9 15 -7 21 8 33 30 21 76 19 76 -5z"
            />
            <path
              d="M7480 415 c0 -98 1 -105 20 -105 18 0 20 7 20 66 0 74 12 104 40 104
            13 0 20 7 20 20 0 25 -26 26 -52 3 -17 -15 -18 -15 -18 0 0 10 -7 17 -15 17
            -12 0 -15 -18 -15 -105z"
            />
            <path
              d="M8167 490 c-34 -40 -41 -80 -23 -123 18 -45 45 -59 104 -55 34 2 48
            8 50 19 3 14 -4 16 -41 12 -36 -4 -49 -1 -66 16 -35 35 -26 41 55 41 l76 0 -7
            38 c-15 83 -98 112 -148 52z m97 -22 c24 -34 20 -38 -39 -38 -47 0 -54 2 -48
            18 17 47 61 57 87 20z"
            />
          </g>
        </svg>
        
        </Link>
       
      </div>

  );
};

export default Logo;
